import React from "react";
import PageHeader from "../components/PageHeader";
import ContactCTA from "../components/ContactCTA";

const ContactPage = () => (
  <>
    <PageHeader title="Contact Us" breadcrumb="Contact Us" />
    <ContactCTA />
  </>
);

export default ContactPage;
